<div class="grid">
    <div class="fr-2">{{ 'voucher.situationFT.address' | translate }}:
        <span class="font-semibold">{{ (store.address$ | async) | formatAddress }}</span>
    </div>

    <app-date-input [form]="form" id="medicalExaminationDate"
        label="voucher.situationFT.medicalExaminationDate"
    ></app-date-input>
    <div class="fh-5 flex-column">
        <div>{{ 'voucher.situationFT.sketchMarking' | translate }}:</div>
        <div class="flex-1 flex-column flex-center">
            <div class="sketchGrid">
                <img #sketch src="assets/images/character-sketch.png" class="sketch-img sketchGrid_item"
                    (load)="onLoad()">
                <canvas #sketchCanvas class="sketchGrid_item cursor-pointer"
                    (click)="click($event)"
                    (mousemove)="dragging($event)"
                    (mousedown)="dragged($event)"
                ></canvas>
            </div>
        </div>
    </div>
    <div>{{ 'voucher.situationFT.conditionRequiringTreatment' | translate }}:</div>
    <app-input-wysiwyg
        [form]="form"
        id="conditionRequiringTreatment"
        editorKey="VoucherDetailSituationFTRequiringTreatment"
        [height]="300"
    ></app-input-wysiwyg>
    <div>{{ 'voucher.situationFT.patientRisks' | translate }}:</div>
    <app-input-wysiwyg
        [form]="form"
        id="patientRisks"
        editorKey="VoucherDetailSituationFTPatientRisks"
        [height]="300"
    ></app-input-wysiwyg>
    <div>{{ 'voucher.situationFT.goal' | translate }}:</div>
    <div>{{ 'voucher.situationFT.sketchDescription' | translate }}:</div>
    <app-input-wysiwyg
        [form]="form"
        id="goal"
        editorKey="VoucherDetailSituationFTGoal"
        [height]="300"
    ></app-input-wysiwyg>
    <app-input-wysiwyg
        [form]="form"
        id="sketchDescription"
        editorKey="VoucherDetailSituationFTSketchDescription"
        [height]="300"
    ></app-input-wysiwyg>
</div>
